import { FC } from 'react'
import QRCodeLib from 'react-qr-code'

export type IQRCode = {
  className?: string
  url: string
}

export const QrCode: FC<IQRCode> = ({ className = '', url }) => {
  return (
    <div className={className}>
      <QRCodeLib value={url} size={128} />
    </div>
  )
}
